import * as THREE from 'three';
import Store from '../Store';

export default class Skybox {
  constructor() {
    // global store
    const { scene } = Store.getState();
    this.dayTexture = null;
    this.nightTexture = null;
    this.skyboxMesh = null;

    scene.background = new THREE.Color(0x222222);

    // Create a sphere geometry that will act as the skybox
    const skyboxGeometry = new THREE.SphereGeometry(500, 60, 40);
    // The inside of the sphere should be visible to the camera
    skyboxGeometry.scale(-1, 1, 1);

    // Load the texture
    const loader = new THREE.TextureLoader();
    loader.load("https://static.mused.org/resting_place_2k.jpg", (texture) => {
      this.dayTexture = texture;
      texture.colorSpace = THREE.SRGBColorSpace;
      texture.needsUpdate = true;

      const skyboxMaterial = new THREE.MeshBasicMaterial({
        map: texture,
        color: new THREE.Color(0.5, 0.5, 0.5),
        transparent: true,
        opacity: 0,
      });

      this.skyboxMesh = new THREE.Mesh(skyboxGeometry, skyboxMaterial);
      this.skyboxMesh.rotation.y = Math.PI / 2

      scene.add(this.skyboxMesh);
    });

    loader.load("https://static.mused.org/kloppenheim_02_2k.jpg", (texture) => {
      this.nightTexture = texture;
      texture.colorSpace = THREE.SRGBColorSpace;
      texture.needsUpdate = true;
    });
  }

  fadeInSkybox() {
    let opacity = 0; // start with an opacity of 0
    const interval = 10; // how often to update the opacity (in milliseconds)
    const increment = interval / 600; // how much to increase the opacity by each time

    const fadeInInterval = setInterval(() => {
      // Increase the opacity
      opacity += increment;
      if (this.skyboxMesh && this.skyboxMesh.material) {
        this.skyboxMesh.material.opacity = opacity;
      }

      // If the opacity reaches 1, stop the interval
      if (opacity >= 1) {
        clearInterval(fadeInInterval);
        if (this.skyboxMesh && this.skyboxMesh.material) {
          this.skyboxMesh.material.opacity = 1; // Ensure the opacity is set to 1
        }
      }
    }, interval);
  }

  fadeOutSkybox() {
    let opacity = 1; // start with an opacity of 0
    const interval = 10; // how often to update the opacity (in milliseconds)
    const increment = interval / 600; // how much to increase the opacity by each time

    const fadeInInterval = setInterval(() => {
      // Increase the opacity
      opacity -= increment;
      if (this.skyboxMesh && this.skyboxMesh.material) {
        this.skyboxMesh.material.opacity = opacity;
      }

      // If the opacity reaches 1, stop the interval
      if (opacity <= 0) {
        clearInterval(fadeInInterval);
        if (this.skyboxMesh && this.skyboxMesh.material) {
          this.skyboxMesh.material.opacity = 0; // Ensure the opacity is set to 1
        }
      }
    }, interval);
  }

  turnOnFog() {
    // global store
    const { scene } = Store.getState();
    const color = 0xeee6d7;  
    const near = 2;
    const far = 1800;

    scene.fog = new THREE.Fog(color, near, far);
  }

  turnOffFog() {
    // global store
    const { scene } = Store.getState();
    scene.fog = null;
  }

  changeToNight() {
    if (this.nightTexture && this.skyboxMesh) {
      this.skyboxMesh.material.map = this.nightTexture;
      this.skyboxMesh.material.needsUpdate = true;
      this.skyboxMesh.rotation.y = 0; 
    }
  }

  changeToDay() {
    if (this.dayTexture && this.skyboxMesh) {
      this.skyboxMesh.material.map = this.dayTexture;
      this.skyboxMesh.material.needsUpdate = true;
      this.skyboxMesh.rotation.y = Math.PI / 2;
    }
  }
}
